var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { BaseShadowless } from '../indicator/BaseShadowless';
let DinapsisMapElementLayerArrowButton = class DinapsisMapElementLayerArrowButton extends BaseShadowless {
    constructor() {
        super(...arguments);
        /**
        * Setting the default value of the opened property to false.
        */
        this.opened = false;
        /**
         * Setting the default value of the position property to an empty string.
         */
        this.position = '';
        this.enabled = true;
    }
    /**
     * Set activate or deactivate class for element.
     * @returns String of css class for element.
     */
    renderEnabledClass() {
        let iconClass = 'material-icons-arrows test-activate';
        if (!this.enabled) {
            iconClass = 'material-icons-arrows deactivate';
        }
        return iconClass;
    }
    /**
     * If the drawer is opened and the position is up, return the up arrow.
     * If the drawer is closed and the position is up,
     * return the down arrow. If the drawer is opened and the position is
     * down, return the down arrow. Otherwise, return the up arrow.
     * @returns The arrowDirection() function returns a template literal.
     */
    arrowDirection() {
        if (this.opened && this.position === 'up') {
            return html `<span class="arrow">
          <span class="${this.renderEnabledClass()}">expand_less</span>
        </span>`;
        }
        if (!this.opened && this.position === 'up') {
            return html `<span class="arrow">
          <span class="${this.renderEnabledClass()}">expand_more</span>
        </span>`;
        }
        if (this.opened && this.position === 'down') {
            return html `<span class="arrow">
          <span class="${this.renderEnabledClass()}">expand_more</span>
        </span>`;
        }
        return html `<span class="arrow">
        <span class="${this.renderEnabledClass()}">expand_less</span>
      </span>`;
    }
    render() {
        if (this.position === 'up') {
            return html `
      <div>
        ${this.arrowDirection()}
      </div>
    `;
        }
        if (this.position === 'down') {
            return html `
      <div>
        ${this.arrowDirection()}
      </div>
    `;
        }
        return '';
    }
};
__decorate([
    property({ type: Boolean })
], DinapsisMapElementLayerArrowButton.prototype, "opened", void 0);
__decorate([
    property({ type: String })
], DinapsisMapElementLayerArrowButton.prototype, "position", void 0);
__decorate([
    property({ type: Boolean })
], DinapsisMapElementLayerArrowButton.prototype, "enabled", void 0);
DinapsisMapElementLayerArrowButton = __decorate([
    customElement('dinapsis-map-element-layer-arrow-button')
], DinapsisMapElementLayerArrowButton);
export { DinapsisMapElementLayerArrowButton };
//# sourceMappingURL=dinapsis-map-element-layer-arrow-button.js.map